import React, { useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    FormControl,
    FormControlLabel,
    RadioGroup,
    Radio,
    TextField,
    Grid,
    ToggleButton,
    ToggleButtonGroup,
    DialogActions,
    Tooltip,
    MenuItem
} from '@mui/material';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { DataGridPro } from '@mui/x-data-grid-pro';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import IosShareIcon from '@mui/icons-material/IosShare';
import CloseIcon from '@mui/icons-material/Close';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SaveIcon from '@mui/icons-material/Save';
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import { styled } from '@mui/material/styles';
import { Autocomplete } from "@mui/material";
import axios from "../../../../axios-order";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useEffect } from 'react';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { withRouter } from "react-router-dom";
import PaymentIcon from '@mui/icons-material/Payment';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { LoadingButton } from '@mui/lab';
import SelectInput from "../../../../components/ui/basicSelectInput";
import { useHistory } from "react-router-dom";
import Popper from '@mui/material/Popper';
import excelIconImage from '../../../../asserts/images/excelicon.svg'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import moment from "moment";
import { useLocation } from "react-router-dom";
import { canRead, canWrite } from "../../../../utils/privilegeUtils";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const months = [
    { value: "April", label: "April" },
    { value: "May", label: "May" },
    { value: "June", label: "June" },
    { value: "July", label: "July" },
    { value: "August", label: "August" },
    { value: "September", label: "September" },
    { value: "October", label: "October" },
    { value: "November", label: "November" },
    { value: "December", label: "December" },
    { value: "January", label: "January" },
    { value: "February", label: "February" },
    { value: "March", label: "March" },
];


const monthsOptions = [
    { label: 'Select All', value: 'ALL' },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" },
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
];

// ── 27Q specific options ────────────────────────────────────────────────────
const minorHead27QOptions = [
    { value: "advance_tax", label: "100 - Advance Tax" },
    { value: "tds_payable", label: "200 - TDS Payable" },
    { value: "tds_regular_assessment_raised_by_it_dept", label: "400 - TDS Regular Assessment Raised by IT Dept" },
];

const StyledIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 20,
    height: 20,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.6)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    transition: 'all 0.3s ease',
    'input:hover ~ &': {
        backgroundColor: '#e0e0e0',
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
    },
}));



const StyledCheckedIcon = styled(StyledIcon)({
    backgroundColor: '#1976d2',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 20,
        height: 20,
        backgroundImage: 'radial-gradient(#fff, #fff 40%, transparent 45%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#1565c0',
    },
});


function CustomRadio(props) {
    return (
        <Radio
            disableRipple
            color="default"
            checkedIcon={<StyledCheckedIcon />}
            icon={<StyledIcon />}
            {...props}
        />
    );
}

// Helper function to get initial form data based on challan type
const getInitialFormData = (challanType) => {
    if (challanType === '24Q') {
        return {
            financial_year: "",
            month: "",
            tan: "",
            major_head: "",
            minor_head: "",
            // section: "",
            // code: "",
            nature_of_payment: "",
            section_as_per_challan: "",
            basic_tax: "",
            surcharge: "0",
            education_cess: "0",
            penalty: "0",
            interest: "",
            fee_234E: "0",
            amount_paid: "",
            bsr_code: "",
            challan_number: "",
            date_of_receipt: "",
            payment_details: [],
        };
    } else {
        return {
            financial_year: "",
            month: "",
            tan: "",
            major_head: "",
            minor_head: "",
            nature_of_payment: "",
            section_as_per_challan: "",
            basic_tax: "",
            surcharge: "0",
            education_cess: "0",
            penalty: "0",
            interest: "",
            fee_234E: "0",
            amount_paid: "",
            bsr_code: "",
            challan_number: "",
            date_of_receipt: "",
        };
    }
};

// Effect to update form data when challanType changes
const TDSChallanRepository = ({ challanType: propChallanType = '26Q' }) => {
    let history = useHistory();
    const location = useLocation();
    const challanType = propChallanType;
    const [tdsChallanRepoData, setTDSChallanRepoData] = useState([])
    const [openUploadDialog, setOpenUploadDialog] = useState(false);
    const [uploadMode, setUploadMode] = useState('upload');
    const [file, setFile] = useState(null);
    const [showFileError, setShowFileError] = useState(false);
    const [isExportingExcel, setIsExportingExcel] = useState(false);
    // const [formData, setFormData] = useState({
    //     financial_year: "",
    //     month: "",
    //     tan: "",
    //     major_head: "",
    //     minor_head: "",
    //     section: "",
    //     section_as_per_challan: "",
    //     basic_tax: "",
    //     surcharge: challanType === '24Q' ? "0" : "",
    //     education_cess: challanType === '24Q' ? "0" : "",
    //     penalty: challanType === '24Q' ? "0" : "",
    //     interest: "",
    //     fee_234E: challanType === '24Q' ? "0" : "",
    //     amount_paid: "",
    //     bsr_code: "",
    //     challan_number: "",
    //     date_of_receipt: "",
    // });
    const [formData, setFormData] = useState(() => getInitialFormData(propChallanType));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [fileName, setFileName] = useState('')
    const [statusView, setStatusView] = useState('unassociated');
    const [challanSubmitLoading, setChallanSubmitLoading] = useState(false)
    const [financialYears, setFinancialYears] = useState([])
    const [openAssociateDialog, setOpenMonthDialog] = useState(false);
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [selectedItem, setSelectedItem] = useState({})
    const [pageSize, setPageSize] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [dataLoading, setDataLoading] = useState(false)
    const [formTouched, setFormTouched] = useState(false);
    const [confirmDiscardOpen, setConfirmDiscardOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingRow, setEditingRow] = useState(null);
    const [openPaymentBreakupDialog, setOpenPaymentBreakupDialog] = useState(false);
    const [paymentBreakupRows, setPaymentBreakupRows] = useState([
        { description: '', section: '', code: '', tax: '', surcharge: '', cess: '', total: '' }
    ]);
    const [openViewBreakupDialog, setOpenViewBreakupDialog] = useState(false);
    const [viewBreakupData, setViewBreakupData] = useState([]);

    const handleBackNavigation = () => {
        history.push('/repoCards');
    };


    useEffect(() => {
        if (!isEditMode && !formTouched) {
            setFormData(getInitialFormData(challanType));
        }
    }, [challanType, isEditMode, formTouched]);


    useEffect(() => {
        // Check if we're returning from the association page
        if (location.state?.returnedFromAssociation) {
            const previousView = location.state.previousView;
            if (previousView) {
                setStatusView(previousView);
            }
            // Clear the state after using it
            history.replace({ ...location, state: {} });
        }
    }, [location]);

    useEffect(() => {
        if (!ValidatorForm.hasValidationRule('isValidDate')) {
            ValidatorForm.addValidationRule('isValidDate', (value) => {
                // If empty → valid (required rule handles it)
                if (!value || value === '') return true;

                // If it's a Date object (from DatePicker) → valid
                if (value instanceof Date && !isNaN(value)) return true;

                // If it's a string like "2025-11-11" (from backend) → valid
                if (typeof value === 'string' && value.includes('-')) {
                    const [y, m, d] = value.split('-');
                    if (y && m && d && y.length === 4) return true;
                }

                // Now validate only manually typed DD/MM/YYYY strings
                const date = moment(value, 'DD/MM/YYYY', true);
                return date.isValid();
            });
        }
        return () => {
            if (ValidatorForm.hasValidationRule('isValidDate')) {
                ValidatorForm.removeValidationRule('isValidDate');
            }
        };
    }, []);

    useEffect(() => {
        setFromYearValues()
        getTdsChallanRepoData()
    }, [statusView, challanType])

    // Pre-fill selected months for manually-entered (non-PDF) challans so the
    // Autocomplete shows the existing month but still lets the user change it
    useEffect(() => {
        if (openAssociateDialog && !selectedItem?.is_pdf_upload && selectedItem?.month_name) {
            const preSelected = monthsOptions.filter(
                (opt) => opt.value === selectedItem.month_name
            );
            setSelectedMonths(preSelected);
        }
    }, [openAssociateDialog, selectedItem]);

    const columnsTdsChallanRepoTable = [
        {
            field: 'view_breakup',
            headerName: '',
            flex: 0.4,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const hasDetails = Array.isArray(params.row.payment_details) && params.row.payment_details.length > 0;
                return (
                    <Tooltip title={hasDetails ? 'View Section-Wise Details' : 'No details available'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={!hasDetails}
                                onClick={() => handleOpenViewBreakupDialog(params.row)}
                            >
                                <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        { field: 'financial_year', headerName: 'Financial Year', flex: 1 },
        { field: 'month_name', headerName: 'Month', flex: 1 },
        { field: 'challan_no', headerName: 'Challan No', flex: 1 },
        { field: 'bsr_code', headerName: 'BSR Code', flex: 1 },
        {
            field: 'date_of_deposit', headerName: 'Paid Date', flex: 1, valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        },

        // { field: 'section', headerName: 'Section', flex: 1 },
        // { field: 'code', headerName: 'Code', flex: 1 },
        { field: 'section', headerName: 'Nature of Payment', flex: 1 },
        {
            field: 'amount_paid',
            headerName: 'Paid Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_amount',
            headerName: 'Associated Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'balance_payable',
            headerName: 'Balance Available',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'attachment',
            headerName: 'Attachment',
            flex: 0.5,
            renderCell: (params) => {
                if (params.row.is_pdf_upload === false) return null
                return (
                    <IconButton color="primary" size="small">
                        <AttachFileIcon onClick={() => downloadFile(params.row)} />
                    </IconButton>
                )
            },
        },
        {
            field: 'associate',
            headerName: 'Associate',
            flex: 0.5,
            renderCell: (params) => (
                canWrite("TDS-FILING") ? <IconButton
                    size="small"
                    sx={{ color: '#212121' }}
                    onClick={() => {
                        setSelectedItem(params.row);
                        setOpenMonthDialog(true);
                    }}
                >
                    <PersonAddAlt1Icon />
                </IconButton> : null
            ),
        },
        {
            field: 'edit',
            headerName: 'Edit',
            flex: 0.5,
            renderCell: (params) => {
                if (!canWrite("TDS-FILING")) return null;
                const canEdit =
                    (params.row.associated_amount === 0 || !params.row.associated_amount) &&
                    !params.row.is_pdf_upload;

                return (
                    <Tooltip title={canEdit ? 'Edit Challan' : 'Cannot edit - associated amount is not 0'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleEdit(params.row)}
                                disabled={!canEdit}
                            >
                                <EditIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: 'delete',
            headerName: 'Delete',
            flex: 0.5,
            renderCell: (params) => {
                if (!canWrite("TDS-FILING")) return null;
                const canDelete = (params.row.associated_amount === 0 || !params.row.associated_amount);

                return (
                    <Tooltip
                        title={
                            canDelete
                                ? 'Delete Challan'
                                : 'Cannot delete — associated amount is not 0'
                        }
                    >
                        <span>
                            <IconButton
                                size="small"
                                // color={canDelete ? 'error' : 'default'}
                                onClick={() => handleDelete(params.row.repository_id)}
                                disabled={!canDelete}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        }
    ];

    const columnsTdsChallanRepoTable24Q = [
        {
            field: 'view_breakup',
            headerName: '',
            flex: 0.4,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const hasDetails = Array.isArray(params.row.payment_details) && params.row.payment_details.length > 0;
                return (
                    <Tooltip title={hasDetails ? 'View Section-Wise Details' : 'No details available'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={!hasDetails}
                                onClick={() => handleOpenViewBreakupDialog(params.row)}
                            >
                                <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        { field: 'financial_year', headerName: 'Financial Year', flex: 1 },
        { field: 'month_name', headerName: 'Month', flex: 1 },
        { field: 'challan_no', headerName: 'Challan No', flex: 1 },
        { field: 'bsr_code', headerName: 'BSR Code', flex: 1 },
        {
            field: 'date_of_deposit', headerName: 'Paid Date', flex: 1, valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        },
        { field: 'nature_of_payment', headerName: 'Nature of Payment', flex: 1 },
        {
            field: 'amount_paid',
            headerName: 'Paid Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_amount',
            headerName: 'Associated Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'balance_payable',
            headerName: 'Balance Available',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'attachment',
            headerName: 'Attachment',
            flex: 0.5,
            renderCell: (params) => {
                if (params.row.is_pdf_upload === false) return null
                return (
                    <IconButton color="primary" size="small">
                        <AttachFileIcon onClick={() => downloadFile24Q(params.row)} />
                    </IconButton>
                )
            },
        },
        {
            field: 'associate',
            headerName: 'Associate',
            flex: 0.5,
            renderCell: (params) => (
                canWrite("TDS-FILING") ? <IconButton
                    size="small"
                    sx={{ color: '#212121' }}
                    onClick={() => {
                        setSelectedItem(params.row);
                        setOpenMonthDialog(true);
                    }}
                >
                    <PersonAddAlt1Icon />
                </IconButton> : null
            ),
        },
        {
            field: 'edit',
            headerName: 'Edit',
            flex: 0.5,
            renderCell: (params) => {
                if (!canWrite("TDS-FILING")) return null;
                const canEdit =
                    (params.row.associated_amount === 0 || !params.row.associated_amount) &&
                    !params.row.is_pdf_upload;

                return (
                    <Tooltip title={canEdit ? 'Edit Challan' : 'Cannot edit - associated amount is not 0'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleEdit24Q(params.row)}
                                disabled={!canEdit}
                            >
                                <EditIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: 'delete',
            headerName: 'Delete',
            flex: 0.5,
            renderCell: (params) => {
                if (!canWrite("TDS-FILING")) return null;
                const canDelete = (params.row.associated_amount === 0 || !params.row.associated_amount);

                return (
                    <Tooltip
                        title={
                            canDelete
                                ? 'Delete Challan'
                                : 'Cannot delete — associated amount is not 0'
                        }
                    >
                        <span>
                            <IconButton
                                size="small"
                                onClick={() => handleDelete24Q(params.row.repository_id)}
                                disabled={!canDelete}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        }
    ];

    // ── 27Q columns (same structure as 26Q, uses 27Q-specific handlers) ────
    const columnsTdsChallanRepoTable27Q = [
        {
            field: 'view_breakup',
            headerName: '',
            flex: 0.4,
            sortable: false,
            filterable: false,
            renderCell: (params) => {
                const hasDetails = Array.isArray(params.row.payment_details) && params.row.payment_details.length > 0;
                return (
                    <Tooltip title={hasDetails ? 'View Section-Wise Details' : 'No details available'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                disabled={!hasDetails}
                                onClick={() => handleOpenViewBreakupDialog(params.row)}
                            >
                                <AddCircleOutlineIcon fontSize="small" />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        { field: 'financial_year', headerName: 'Financial Year', flex: 1 },
        { field: 'month_name', headerName: 'Month', flex: 1 },
        { field: 'challan_no', headerName: 'Challan No', flex: 1 },
        { field: 'bsr_code', headerName: 'BSR Code', flex: 1 },
        {
            field: 'date_of_deposit', headerName: 'Paid Date', flex: 1,
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
            },
        },
        { field: 'section', headerName: 'Nature of Payment', flex: 1 },
        {
            field: 'amount_paid',
            headerName: 'Paid Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_amount',
            headerName: 'Associated Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'balance_payable',
            headerName: 'Balance Available',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'attachment',
            headerName: 'Attachment',
            flex: 0.5,
            renderCell: (params) => {
                if (params.row.is_pdf_upload === false) return null;
                return (
                    <IconButton color="primary" size="small">
                        {/* PDF download endpoint for 27Q — to be wired once API is available */}
                        <AttachFileIcon onClick={() => downloadFile27Q(params.row)} />
                    </IconButton>
                );
            },
        },
        {
            field: 'associate',
            headerName: 'Associate',
            flex: 0.5,
            renderCell: (params) => (
                <IconButton
                    size="small"
                    sx={{ color: '#212121' }}
                    onClick={() => {
                        setSelectedItem(params.row);
                        setOpenMonthDialog(true);
                    }}
                >
                    <PersonAddAlt1Icon />
                </IconButton>
            ),
        },
        {
            field: 'edit',
            headerName: 'Edit',
            flex: 0.5,
            renderCell: (params) => {
                const canEdit =
                    (params.row.associated_amount === 0 || !params.row.associated_amount) &&
                    !params.row.is_pdf_upload;

                return (
                    <Tooltip title={canEdit ? 'Edit Challan' : 'Cannot edit - associated amount is not 0'}>
                        <span>
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleEdit27Q(params.row)}
                                disabled={!canEdit}
                            >
                                <EditIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: 'delete',
            headerName: 'Delete',
            flex: 0.5,
            renderCell: (params) => {
                const canDelete = (params.row.associated_amount === 0 || !params.row.associated_amount);

                return (
                    <Tooltip
                        title={
                            canDelete
                                ? 'Delete Challan'
                                : 'Cannot delete — associated amount is not 0'
                        }
                    >
                        <span>
                            <IconButton
                                size="small"
                                onClick={() => handleDelete27Q(params.row.repository_id)}
                                disabled={!canDelete}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        },
    ];
    // ────────────────────────────────────────────────────────────────────────


    useEffect(() => {
        setFromYearValues()
        getTdsChallanRepoData()
    }, [statusView, challanType])

    const handleDelete = (repo_id) => {

        axios
            .delete(`/delete_challan/${repo_id}`)
            .then((response) => {
                getTdsChallanRepoData();
            })
            .catch((error) => {
                console.error('Error deleting challan:', error);
            });
    };

    const handleDelete24Q = (repo_id) => {

        axios
            .delete(`/delete_challan_24q/${repo_id}`)
            .then((response) => {
                getTdsChallanRepoData();
            })
            .catch((error) => {
                console.error('Error deleting challan:', error);
            });
    };

    // ── 27Q delete ──────────────────────────────────────────────────────────
    const handleDelete27Q = (repo_id) => {
        axios
            .delete(`/delete_challan_27q/${repo_id}`)
            .then(() => {
                getTdsChallanRepoData();
            })
            .catch((error) => {
                console.error('Error deleting 27Q challan:', error);
            });
    };
    // ────────────────────────────────────────────────────────────────────────

    const handleEdit = (row) => {
        // Fill the form with the row values
        setFormData({
            financial_year: row.financial_year || '',
            month: row.month_name || '',
            tan: row.tan || '',
            major_head: row.major_head || '',
            minor_head: row.minor_head || '',
            // section: row.section || '',
            // code: row.code || '',
            nature_of_payment: row.section || row.nature_of_payment || '',
            section_as_per_challan: row.section_as_per_challan || '',
            basic_tax: row.basic_tax || '',
            surcharge: row.surcharge ?? '',
            education_cess: row.education_cess ?? '',
            penalty: row.penalty ?? '',
            interest: row.interest || '',
            fee_234E: row.fee_234E ?? row.fee_under_section_234e ?? '',
            amount_paid: row.amount_paid || '',
            bsr_code: row.bsr_code || '',
            challan_number: row.challan_no || '',
            date_of_receipt: row.date_of_deposit || '',
            payment_details: row.payment_details || [],
        });

        setUploadMode('manual');
        setIsEditMode(true);
        setEditingRow(row);
        setFormTouched(false);
        setOpenUploadDialog(true);
    };

    const handleEdit24Q = (row) => {
        // Fill the form with the row values
        setFormData({
            financial_year: row.financial_year || '',
            month: row.month_name || '',
            tan: row.tan || '',
            major_head: row.major_head || '',
            minor_head: row.minor_head || '',
            nature_of_payment: row.section || row.nature_of_payment || '',
            section_as_per_challan: row.section_as_per_challan || '',
            basic_tax: row.basic_tax || '',
            surcharge: row.surcharge || '0',
            education_cess: row.education_cess || '0',
            penalty: row.penalty || '0',
            interest: row.interest || '',
            fee_234E: row.fee_234E ?? row.fee_under_section_234e ?? '0',
            amount_paid: row.amount_paid || '',
            bsr_code: row.bsr_code || '',
            challan_number: row.challan_no || '',
            date_of_receipt: row.date_of_deposit || '',
            payment_details: row.payment_details || [],
        });

        setUploadMode('manual');   // force manual entry
        setIsEditMode(true);
        setEditingRow(row);        // keep reference for the API call
        setFormTouched(false);
        setOpenUploadDialog(true);
    };

    // ── 27Q edit ────────────────────────────────────────────────────────────
    const handleEdit27Q = (row) => {
        setFormData({
            financial_year: row.financial_year || '',
            month: row.month_name || '',
            tan: row.tan || '',
            major_head: row.major_head || '',
            minor_head: row.minor_head || '',
            nature_of_payment: row.section || row.nature_of_payment || '',
            section_as_per_challan: row.section_as_per_challan || '',
            basic_tax: row.basic_tax || '',
            surcharge: row.surcharge || '0',
            education_cess: row.education_cess || '0',
            penalty: row.penalty || '0',
            interest: row.interest || '',
            fee_234E: row.fee_234E ?? row.fee_under_section_234e ?? '0',
            amount_paid: row.amount_paid || '',
            bsr_code: row.bsr_code || '',
            challan_number: row.challan_no || '',
            date_of_receipt: row.date_of_deposit || '',
            payment_details: row.payment_details || [],
        });

        setUploadMode('manual');
        setIsEditMode(true);
        setEditingRow(row);
        setFormTouched(false);
        setOpenUploadDialog(true);
    };
    // ────────────────────────────────────────────────────────────────────────

    const calculateAmountPaid = () => {
        const fields = ['basic_tax', 'surcharge', 'education_cess', 'penalty', 'interest', 'fee_234E'];
        const totalAmount = fields.reduce((sum, field) => {
            const value = parseFloat(formData[field]);
            return sum + (isNaN(value) ? 0 : value);
        }, 0);

        setFormData((prev) => ({
            ...prev,
            amount_paid: totalAmount.toFixed(2),
        }));
    };

    useEffect(() => {
        calculateAmountPaid();
    }, [
        formData.basic_tax,
        formData.surcharge,
        formData.education_cess,
        formData.penalty,
        formData.interest,
        formData.fee_234E,
    ]);


    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };


    const setFromYearValues = () => {
        let current_year = new Date().getFullYear();
        let yearArr = [];
        for (let i = current_year - 7; i <= current_year + 5; i++) {
            let startYear = i;
            let endYear = i + 1;
            let endYearShort = endYear.toString().slice(-2);
            yearArr.push({ id: `${startYear}-${endYearShort}`, value: `${startYear}-${endYearShort}` });
        }
        setFinancialYears(yearArr)
    };

    const getCurrentFinancialYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0 = Jan ... 3 = April

        return month >= 3
            ? `${year}-${(year + 1).toString().slice(-2)}`
            : `${year - 1}-${year.toString().slice(-2)}`;
    };

    const isCurrentFYSelected = formData.financial_year === getCurrentFinancialYear();

    const validatePaymentDetails = () => {
        if (!isCurrentFYSelected) return true;

        const rows = formData.payment_details || [];
        if (rows.length === 0) return false;

        return rows.every(
            (row) =>
                row.description?.toString().trim() &&
                row.code?.toString().trim() &&
                row.tax?.toString().trim()
        );
    };

    // Function to close Snackbar
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");
    };


    const getTdsChallanRepoData = () => {
        setDataLoading(true)
        const endpoint = challanType === '24Q'
            ? `/get_challan_summary_details_24q/${localStorage.getItem("business_entity_id")}/${statusView}`
            : challanType === '27Q'
                ? `/get_challan_summary_details_27q/${localStorage.getItem("business_entity_id")}/${statusView}`
                : `/get_challan_repository_details/${localStorage.getItem("business_entity_id")}/${statusView}`;

        axios.get(endpoint)
            .then((res) => {
                if (res?.data?.status) {
                    setTDSChallanRepoData(res?.data?.records)
                }
            }).catch((err) => {

            }).finally(() => {
                setDataLoading(false)
            })
    }

    const downloadPDF = (base64Data, fileName) => {
        const linkSource = base64Data;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const downloadFile = (row) => {
        axios
            .get(`/download_challan_pdf/${localStorage.getItem("business_entity_id")}/${row.repository_id}`)
            .then((res) => {
                if (typeof res.data === "undefined") {
                } else {
                    downloadPDF(res.data.records, row.document_name);
                }
            });
    };

    const downloadFile24Q = (row) => {
        axios
            .get(`/get_repository_pdf_documnet_24q/${localStorage.getItem("business_entity_id")}/${row.repository_id}`)
            .then((res) => {
                if (typeof res.data === "undefined") {
                } else {
                    downloadPDF(res.data.records, row.document_name);
                }
            });
    };

    const downloadFile27Q = (row) => {
        axios
            .get(`/get_repository_pdf_documnet_27q/${localStorage.getItem("business_entity_id")}/${row.repository_id}`)
            .then((res) => {
                if (typeof res.data !== "undefined") {
                    downloadPDF(res.data.records, row.document_name);
                }
            });
    };


    const handleChange = (e) => {
        const { name, value } = e.target || e;
        setFormTouched(true);

        if (name === 'financial_year') {
            setFormData((prev) => ({
                ...prev,
                financial_year: value,
                payment_details: value === getCurrentFinancialYear() ? (prev.payment_details || []) : [],
            }));
            return;
        }

        // Auto-clear "0" ONLY for 24Q fields
        const fieldsToAutoClear = ['surcharge', 'education_cess', 'penalty', 'fee_234E'];

        if (challanType === '24Q' && fieldsToAutoClear.includes(name) && formData[name] === '0' && value !== '0') {
            setFormData((prev) => ({ ...prev, [name]: value.replace(/^0/, '') }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };

    const emptyPaymentRow = () => ({
        description: '', section: '', code: '', tax: '', surcharge: '', cess: '', total: ''
    });

    const handleOpenPaymentBreakupDialog = () => {
        setPaymentBreakupRows(
            formData.payment_details && formData.payment_details.length > 0
                ? formData.payment_details
                : [emptyPaymentRow()]
        );
        setOpenPaymentBreakupDialog(true);
    };

    const handleClosePaymentBreakupDialog = () => {
        setOpenPaymentBreakupDialog(false);
    };

    const handleAddPaymentRow = () => {
        setPaymentBreakupRows((prev) => [...prev, emptyPaymentRow()]);
    };

    const handleDeletePaymentRow = (index) => {
        setPaymentBreakupRows((prev) => prev.filter((_, i) => i !== index));
    };

    const handlePaymentRowChange = (index, field, value) => {
        setPaymentBreakupRows((prev) => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };

            // auto-calc total = tax + surcharge + cess, mirrors your amount_paid logic
            if (['tax', 'surcharge', 'cess'].includes(field)) {
                const tax = parseFloat(updated[index].tax) || 0;
                const surcharge = parseFloat(updated[index].surcharge) || 0;
                const cess = parseFloat(updated[index].cess) || 0;
                updated[index].total = (tax + surcharge + cess).toFixed(2);
            }
            return updated;
        });
    };

    const handleSavePaymentBreakup = () => {
        if (isCurrentFYSelected) {
            const hasInvalidRow = paymentBreakupRows.some(
                (row) =>
                    !row.description?.toString().trim() ||
                    !row.code?.toString().trim() ||
                    !row.tax?.toString().trim()
            );

            if (hasInvalidRow) {
                handleSnackbarOpen(
                    'Description, Code and Tax are mandatory for the current financial year.',
                    'warning'
                );
                return;
            }
        }

        setFormTouched(true);
        setFormData((prev) => ({ ...prev, payment_details: paymentBreakupRows }));
        setOpenPaymentBreakupDialog(false);
    };

    const isLastRowFilled = () => {
        const lastRow = paymentBreakupRows[paymentBreakupRows.length - 1];
        if (!lastRow) return false;
        return Object.entries(lastRow).some(
            ([key, val]) => key !== 'total' && String(val).trim() !== ''
        );
    };

    const handleOpenViewBreakupDialog = (row) => {
        setViewBreakupData(row.payment_details || []);
        setOpenViewBreakupDialog(true);
    };

    const handleCloseViewBreakupDialog = () => {
        setOpenViewBreakupDialog(false);
        setViewBreakupData([]);
    };


    const handleFileChange = (event) => {
        if (event.target.files[0]) {
            const fileData = event.target.files[0];
            const fileName = fileData.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(fileData);
            reader.onload = function () {
                const fileValue = reader.result;
                setFormTouched(true);
                setFile(fileValue);
            };
            event.target.value = null;
        }

    };


    const handleSubmit = () => {
        console.log("coming into handle sumbit function .......................................")

        if (uploadMode === "upload") {
            if (!file) {
                setShowFileError(true);
                return;
            }
            setChallanSubmitLoading(true)
            const payLoadData = {
                file: file,
                document_name: fileName,
                date_of_receipt: moment(formData.date_of_receipt).format("YYYY-MM-DD"),
                business_entity_id: localStorage.getItem("business_entity_id"),
            }

            // Use different endpoint based on challanType
            const uploadEndpoint = challanType === '24Q'
                ? '/pdf_challan_upload_24q'
                : challanType === '27Q'
                    ? '/pdf_challan_upload_27q'
                    : '/pdf_challan_upload';

            axios.post(uploadEndpoint, payLoadData)
                .then((res) => {
                    if (res?.data?.status) {
                        handleSnackbarOpen(res?.data?.msg, 'success')
                        closeAndResetForm()
                        getTdsChallanRepoData()
                    } else {
                        handleSnackbarOpen(res?.data?.message, 'warning')
                        return;
                    }
                }).catch((err) => {
                    handleSnackbarOpen('Something went wrong!', 'error');
                    return;
                }).finally(() => {
                    setChallanSubmitLoading(false)
                })
        } else {
            if (!validatePaymentDetails()) {
                handleSnackbarOpen(
                    'TDS/TCS Section-Wise Details (Description, Code and Tax) are mandatory for the current financial year.',
                    'warning'
                );
                return;
            }

            setChallanSubmitLoading(true)

            // Create payload and conditionally exclude late_filing_fee for 26Q
            const payLoadData = {
                ...formData,
                payment_details: isCurrentFYSelected ? (formData.payment_details || []) : [],
                date_of_receipt: moment(formData.date_of_receipt).format("YYYY-MM-DD"),
                business_entity_id: localStorage.getItem("business_entity_id"),
            };


            if (isEditMode && editingRow?.repository_id) {
                payLoadData.repository_id = editingRow.repository_id;

                const editEndpoint = challanType === '24Q'
                    ? '/edit_challan_24q'
                    : challanType === '27Q'
                        ? '/edit_challan_27q'
                        : '/edit_challan';

                axios.post(editEndpoint, payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message || 'Challan updated successfully!', 'success');
                            closeAndResetForm();
                            getTdsChallanRepoData();
                        } else {
                            handleSnackbarOpen(res?.data?.message || 'Update failed.', 'warning');
                        }
                        setEditingRow(null)
                        setIsEditMode(false)
                    })
                    .catch(() => {
                        handleSnackbarOpen('Something went wrong!', 'error');
                    })
                    .finally(() => {
                        setChallanSubmitLoading(false);
                        setEditingRow(null)
                        setIsEditMode(false)
                    });

            } else {
                console.log('coming into create function...........')

                // Use different endpoint based on challanType
                const manualUploadEndpoint = challanType === '24Q'
                    ? '/challan_repository_manual_upload_24q'
                    : challanType === '27Q'
                        ? '/challan_repository_manual_upload_27q'
                        : '/challan_repository_manual_upload';

                axios.post(manualUploadEndpoint, payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message, 'success')
                            closeAndResetForm()
                            getTdsChallanRepoData()
                        } else {
                            handleSnackbarOpen(res?.data?.message, 'warning')
                            return;
                        }
                    }).catch((err) => {
                        handleSnackbarOpen('Something went wrong!', 'error');
                        return;
                    }).finally(() => {
                        setChallanSubmitLoading(false)
                    })
            }
        }
    };


    const CustomRadioButtons = () => {
        return (
            <FormControl sx={{ mb: 3 }}>
                <RadioGroup
                    row
                    value={uploadMode}
                    onChange={(e) => setUploadMode(e.target.value)}
                    name="challan-mode"
                    sx={{
                        display: 'flex',
                        gap: 4,
                        flexWrap: 'wrap',
                        justifyContent: 'flex-start',
                    }}
                >
                    <FormControlLabel
                        value="upload"
                        control={<CustomRadio />}
                        label={
                            <Box>
                                <Typography variant="body1" fontWeight={600}>
                                    Upload Challan PDF
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Select and upload a PDF of challan
                                </Typography>
                            </Box>
                        }
                        disabled={isEditMode}
                        sx={{
                            m: 0,
                            px: 2,
                            py: 1,
                            border: uploadMode === 'upload' ? '2px solid #1976d2' : '1px solid #ccc',
                            borderRadius: 2,
                            backgroundColor: uploadMode === 'upload' ? '#e3f2fd' : '#f9f9f9',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#f0f7ff',
                            },
                        }}
                    />

                    <FormControlLabel
                        value="manual"
                        control={<CustomRadio />}
                        label={
                            <Box>
                                <Typography variant="body1" fontWeight={600}>
                                    Enter Details Manually
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Fill in the challan information form
                                </Typography>
                            </Box>
                        }
                        sx={{
                            m: 0,
                            px: 2,
                            py: 1,
                            border: uploadMode === 'manual' ? '2px solid #1976d2' : '1px solid #ccc',
                            borderRadius: 2,
                            backgroundColor: uploadMode === 'manual' ? '#e3f2fd' : '#f9f9f9',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#f0f7ff',
                            },
                        }}
                    />
                </RadioGroup>
            </FormControl>
        );
    };


    const handleCloseDialog = () => {
        if (formTouched || file) {
            setConfirmDiscardOpen(true);
        } else {
            closeAndResetForm();
        }
    };


    const closeAndResetForm = () => {
        // setFormData({
        //     month: '',
        //     quarter: '',
        //     major_head: '',
        //     minor_head: '',
        //     section: '',
        //     section_as_per_challan: '',
        //     basic_tax: '',
        //     surcharge: challanType === '24Q' ? '0' : '',
        //     education_cess: challanType === '24Q' ? '0' : '',
        //     penalty: challanType === '24Q' ? '0' : '',
        //     interest: '',
        //     fee_under_sec_234e: challanType === '24Q' ? '0' : '',
        //     amount_paid: '',
        //     bsr_code: '',
        //     challan_number: '',
        //     date_of_receipt: '',
        // });
        setFormData(getInitialFormData(challanType));
        setFile(null);
        setUploadMode('upload');
        setFormTouched(false);
        setOpenUploadDialog(false);
    };


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };


    const handleDownloadReport = (item) => {
        setIsExportingExcel(true);
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `TDS Challan Report Summary.xlsx`;
        const payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            data_type: statusView
        }

        const endpoint = challanType === '24Q'
            ? '/generate_tds_challan_excel_report_24q'
            : challanType === '27Q'
                ? '/generate_tds_challan_excel_report_27q'
                : '/generate_tds_challan_excel_report';

        axios
            .post(endpoint, payLoadData)
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setIsExportingExcel(false);
            });
    }

    // ── 27Q manual entry form ───────────────────────────────────────────────
    const render27QFormFields = () => (
        <>
            {/* Financial Year */}
            <Grid item xs={12} sm={6} md={4}>
                <SelectInput
                    choice_id="id"
                    requiredField="*"
                    validator={["required"]}
                    errorMsg={["This field is required"]}
                    choice_name="value"
                    SelectLabel="Financial Year"
                    name="financial_year"
                    value={formData.financial_year ?? ""}
                    textOnchangeFunction={handleChange}
                    choices={financialYears}
                />
            </Grid>

            {/* Month */}
            <Grid item xs={12} sm={6} md={4} mt={2}>
                <Autocomplete
                    options={months}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    value={months.find((opt) => opt.value === formData.month) || null}
                    onChange={(e, newValue) => {
                        setFormTouched(true);
                        setFormData((prev) => ({ ...prev, month: newValue?.value || "" }));
                    }}
                    renderInput={(params) => (
                        <TextValidator
                            {...params}
                            name="month"
                            label={<span>Month <span style={{ color: 'red' }}>*</span></span>}
                            variant="outlined"
                            value={formData.month}
                            size="small"
                            validators={["required"]}
                            errorMessages={["This field is required"]}
                        />
                    )}
                    sx={{ '& .MuiInputBase-root': { fontSize: '1rem', height: 42, minHeight: 42 } }}
                />
            </Grid>

            {/* TAN */}
            <Grid item xs={12} sm={6} md={4} mt={2}>
                <TextValidator
                    label={<span>TAN <span style={{ color: 'red' }}>*</span></span>}
                    name="tan"
                    value={formData.tan}
                    onChange={handleChange}
                    placeholder="AAAA12345A"
                    validators={['required', "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                    errorMessages={['This field is required', 'Invalid format (e.g., ABCD12345Z)']}
                    fullWidth
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 10 }}
                />
            </Grid>

            {/* Major Head */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Major Head <span style={{ color: 'red' }}>*</span></span>}
                    name="major_head"
                    value={formData.major_head}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Required"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                />
            </Grid>

            {/* Minor Head — 27Q specific options */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    select
                    label={<span>Minor Head <span style={{ color: 'red' }}>*</span></span>}
                    name="minor_head"
                    value={formData.minor_head}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 300 } } } }}
                >
                    {minorHead27QOptions.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </TextValidator>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={
                        <span>
                            Nature of Payment <span style={{ color: 'red' }}>*</span>
                        </span>
                    }
                    name="nature_of_payment"
                    value={formData.nature_of_payment}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                />
            </Grid>

            {/* Basic Tax */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Basic Tax <span style={{ color: 'red' }}>*</span></span>}
                    name="basic_tax"
                    value={formData.basic_tax}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Required"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                />
            </Grid>

            {/* Surcharge */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Surcharge <span style={{ color: 'red' }}>*</span></span>}
                    name="surcharge"
                    value={formData.surcharge}
                    onChange={handleChange}
                    onFocus={(e) => {
                        if (e.target.value === '0') setFormData((prev) => ({ ...prev, surcharge: '' }));
                    }}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    fullWidth
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    inputProps={{ maxLength: 15 }}
                    size="small"
                    variant="outlined"
                />
            </Grid>

            {/* Health and Education Cess */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Health and Education Cess <span style={{ color: 'red' }}>*</span></span>}
                    name="education_cess"
                    value={formData.education_cess}
                    onChange={handleChange}
                    onFocus={(e) => {
                        if (e.target.value === '0') setFormData((prev) => ({ ...prev, education_cess: '' }));
                    }}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    inputProps={{ maxLength: 15 }}
                    fullWidth
                    size="small"
                    variant="outlined"
                />
            </Grid>

            {/* Penalty */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Penalty <span style={{ color: 'red' }}>*</span></span>}
                    name="penalty"
                    value={formData.penalty}
                    onChange={handleChange}
                    onFocus={(e) => {
                        if (e.target.value === '0') setFormData((prev) => ({ ...prev, penalty: '' }));
                    }}
                    fullWidth
                    inputProps={{ maxLength: 15 }}
                    validators={["required"]}
                    errorMessages={["This field is required"]}
                    size="small"
                    variant="outlined"
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                />
            </Grid>

            {/* Interest */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Interest</span>}
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    fullWidth
                    size="small"
                    variant="outlined"
                />
            </Grid>

            {/* Fee Under Sec 234E */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Fee Under Sec 234E</span>}
                    name="fee_234E"
                    value={formData.fee_234E}
                    onChange={handleChange}
                    onFocus={(e) => {
                        if (e.target.value === '0') setFormData((prev) => ({ ...prev, fee_234E: '' }));
                    }}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    fullWidth
                    size="small"
                    variant="outlined"
                />
            </Grid>

            {/* Amount Paid (auto-calculated, read-only) */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Amount Paid <span style={{ color: 'red' }}>*</span></span>}
                    name="amount_paid"
                    value={formData.amount_paid}
                    onChange={handleChange}
                    validators={["required"]}
                    errorMessages={["Required"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    InputProps={{ readOnly: true }}
                />
            </Grid>

            {/* BSR Code */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>BSR Code <span style={{ color: 'red' }}>*</span></span>}
                    name="bsr_code"
                    value={formData.bsr_code}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    validators={["required", "matchRegexp:^[0-9]{7}$"]}
                    errorMessages={["BSR Code is required", "Must be a valid BSR Code"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 7 }}
                />
            </Grid>

            {/* Challan Number */}
            <Grid item xs={12} sm={6} md={4}>
                <TextValidator
                    label={<span>Challan Number <span style={{ color: 'red' }}>*</span></span>}
                    name="challan_number"
                    value={formData.challan_number}
                    onChange={handleChange}
                    onKeyPress={(e) => {
                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                    }}
                    validators={["required", "matchRegexp:^[0-9]{5}$"]}
                    errorMessages={["Challan Number is required", "Must be a valid Challan number"]}
                    fullWidth
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 5 }}
                />
            </Grid>

            {/* Date of Receipt */}
            <Grid item xs={12} sm={6} md={4}>
                <label>
                    Date of Receipt <span style={{ color: "red" }}>*</span>:
                </label>
                <ValidatedDatePicker
                    name="date_of_receipt"
                    value={formData.date_of_receipt}
                    onChange={(v) => handleChange({ name: "date_of_receipt", value: v })}
                    requiredField="*"
                    validators={["required", "isValidDate"]}
                    errorMessages={["This field is required", "Invalid date format. Use DD/MM/YYYY"]}
                />
            </Grid>

            {/* TDS/TCS Section-Wise Payment Details */}
            {renderPaymentDetailsButton()}
        </>
    );
    // ────────────────────────────────────────────────────────────────────────

    const renderPaymentBreakupDialog = () => (
        <Dialog
            open={openPaymentBreakupDialog}
            onClose={handleClosePaymentBreakupDialog}
            PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden', width: 920, maxWidth: '90vw' } }}
        >
            <DialogTitle
                sx={{
                    backgroundColor: '#0d3b66',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    px: 2,
                }}
            >
                <Typography variant="body1" fontWeight={700}>
                    TDS/TCS Section-Wise Payment Details
                </Typography>
                <IconButton size="small" onClick={handleClosePaymentBreakupDialog} sx={{ color: '#fff' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ mt: 1.5, px: 2, pb: 2, overflowX: 'hidden' }}>
                <Box sx={{ width: '100%' }}>
                    <Grid container spacing={1} sx={{ mb: 0.75, width: '100%', mx: 0 }}>
                        <Grid item xs={2.4}>
                            <Typography variant="caption" fontWeight={700} color="text.secondary">
                                DESCRIPTION{isCurrentFYSelected && <span style={{ color: 'red' }}> *</span>}
                            </Typography>
                        </Grid>
                        <Grid item xs={1.5}><Typography variant="caption" fontWeight={700} color="text.secondary">SECTION</Typography></Grid>
                        <Grid item xs={1.4}>
                            <Typography variant="caption" fontWeight={700} color="text.secondary">
                                CODE{isCurrentFYSelected && <span style={{ color: 'red' }}> *</span>}
                            </Typography>
                        </Grid>
                        <Grid item xs={1.6}>
                            <Typography variant="caption" fontWeight={700} color="text.secondary">
                                TAX{isCurrentFYSelected && <span style={{ color: 'red' }}> *</span>}
                            </Typography>
                        </Grid>
                        <Grid item xs={1.6}><Typography variant="caption" fontWeight={700} color="text.secondary">SURCHARGE</Typography></Grid>
                        <Grid item xs={1.6}><Typography variant="caption" fontWeight={700} color="text.secondary">CESS</Typography></Grid>
                        <Grid item xs={1.5}><Typography variant="caption" fontWeight={700} color="text.secondary">TOTAL</Typography></Grid>
                        <Grid item xs={0.4} />
                    </Grid>

                    {paymentBreakupRows.map((row, index) => (
                        <Grid container spacing={1} alignItems="center" key={index} sx={{ mb: 0.75, width: '100%', mx: 0 }}>
                            <Grid item xs={2.4}>
                                <TextField
                                    size="small" fullWidth placeholder="Description"
                                    value={row.description}
                                    onChange={(e) => handlePaymentRowChange(index, 'description', e.target.value)}
                                    error={isCurrentFYSelected && !row.description?.toString().trim()}
                                />
                            </Grid>
                            <Grid item xs={1.5}>
                                <TextField
                                    size="small" fullWidth placeholder="Section"
                                    value={row.section}
                                    onChange={(e) => handlePaymentRowChange(index, 'section', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1.4}>
                                <TextField
                                    size="small" fullWidth placeholder="Code"
                                    value={row.code}
                                    onChange={(e) => handlePaymentRowChange(index, 'code', e.target.value)}
                                    error={isCurrentFYSelected && !row.code?.toString().trim()}
                                />
                            </Grid>
                            <Grid item xs={1.6}>
                                <TextField
                                    size="small" fullWidth placeholder="Tax"
                                    value={row.tax}
                                    onChange={(e) => handlePaymentRowChange(index, 'tax', e.target.value)}
                                    onKeyPress={(e) => {
                                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                                    }}
                                    error={isCurrentFYSelected && !row.tax?.toString().trim()}
                                />
                            </Grid>
                            <Grid item xs={1.6}>
                                <TextField
                                    size="small" fullWidth placeholder="Surcharge"
                                    value={row.surcharge}
                                    onChange={(e) => handlePaymentRowChange(index, 'surcharge', e.target.value)}
                                    onKeyPress={(e) => {
                                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1.6}>
                                <TextField
                                    size="small" fullWidth placeholder="Cess"
                                    value={row.cess}
                                    onChange={(e) => handlePaymentRowChange(index, 'cess', e.target.value)}
                                    onKeyPress={(e) => {
                                        if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                        if (e.key === '.' && e.target.value.includes('.')) e.preventDefault();
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1.5}>
                                <TextField
                                    size="small" fullWidth placeholder="Total"
                                    value={row.total}
                                    InputProps={{ readOnly: true }}
                                />
                            </Grid>
                            <Grid item xs={0.4}>
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => handleDeletePaymentRow(index)}
                                    disabled={paymentBreakupRows.length === 1}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    ))}

                    <Button
                        onClick={handleAddPaymentRow}
                        disabled={!isLastRowFilled()}
                        sx={{ textTransform: 'none', mt: 1, fontWeight: 600 }}
                    >
                        + Add Row
                    </Button>
                </Box>

                <Stack direction="row" justifyContent="flex-end" spacing={2} mt={2.5}>
                    <Button onClick={handleClosePaymentBreakupDialog} color="secondary" sx={{ textTransform: 'none' }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSavePaymentBreakup}
                        sx={{ textTransform: 'none', backgroundColor: '#0d3b66' }}
                    >
                        Save
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );

    const renderPaymentDetailsButton = () => {
        const hasDetails = formData.payment_details?.length > 0;

        return (
            <Grid item xs={12} sm={6} md={4} sx={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip
                    title={!isCurrentFYSelected ? 'Section-wise details are only applicable for the current financial year' : ''}
                >
                    <span>
                        <Button
                            variant={hasDetails ? "contained" : "outlined"}
                            onClick={handleOpenPaymentBreakupDialog}
                            disabled={!isCurrentFYSelected}
                            startIcon={<ReceiptLongIcon />}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: 2,
                                px: 2.5,
                                py: 1,
                                ...(hasDetails
                                    ? {
                                        backgroundColor: '#0d3b66',
                                        color: '#fff',
                                        '&:hover': { backgroundColor: '#0a2e51' },
                                    }
                                    : {
                                        borderColor: '#0d3b66',
                                        color: '#0d3b66',
                                        borderStyle: 'dashed',
                                        '&:hover': {
                                            backgroundColor: '#f0f7ff',
                                            borderColor: '#0d3b66',
                                        },
                                    }),
                                '&.Mui-disabled': {
                                    borderColor: 'rgba(0,0,0,0.26)',
                                    color: 'rgba(0,0,0,0.38)',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            {hasDetails
                                ? `TDS/TCS Section-Wise Details (${formData.payment_details.length})`
                                : 'Add TDS/TCS Section-Wise Details'}
                        </Button>
                    </span>
                </Tooltip>
            </Grid>
        );
    };

    const renderViewBreakupDialog = () => (
        <Dialog
            open={openViewBreakupDialog}
            onClose={handleCloseViewBreakupDialog}
            PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden', width: 920, maxWidth: '90vw' } }}
        >
            <DialogTitle
                sx={{
                    backgroundColor: '#0d3b66',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    py: 1,
                    px: 2,
                }}
            >
                <Typography variant="body1" fontWeight={700}>
                    TDS/TCS Section-Wise Payment Details
                </Typography>
                <IconButton size="small" onClick={handleCloseViewBreakupDialog} sx={{ color: '#fff' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{ mt: 1.5, px: 2, pb: 2, overflowX: 'auto' }}>
                {viewBreakupData.length === 0 ? (
                    <Typography variant="body2" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                        No breakup details found.
                    </Typography>
                ) : (
                    <Box sx={{ minWidth: 760 }}>
                        <Grid container spacing={1} sx={{ mb: 0.75, width: '100%', mx: 0 }}>
                            <Grid item xs={4}><Typography variant="caption" fontWeight={700} color="text.secondary">DESCRIPTION</Typography></Grid>
                            <Grid item xs={2}><Typography variant="caption" fontWeight={700} color="text.secondary">SECTION</Typography></Grid>
                            <Grid item xs={1.2}><Typography variant="caption" fontWeight={700} color="text.secondary">CODE</Typography></Grid>
                            <Grid item xs={1.2}><Typography variant="caption" fontWeight={700} color="text.secondary">TAX</Typography></Grid>
                            <Grid item xs={1.3}><Typography variant="caption" fontWeight={700} color="text.secondary">SURCHARGE</Typography></Grid>
                            <Grid item xs={1.1}><Typography variant="caption" fontWeight={700} color="text.secondary">CESS</Typography></Grid>
                            <Grid item xs={1.2}><Typography variant="caption" fontWeight={700} color="text.secondary">TOTAL</Typography></Grid>
                        </Grid>

                        {viewBreakupData.map((row, index) => (
                            <Grid
                                container
                                spacing={1}
                                alignItems="center"
                                key={row.detail_id ?? index}
                                sx={{ mb: 0.75, width: '100%', mx: 0, py: 0.5, borderBottom: '1px solid #f0f0f0' }}
                            >
                                <Grid item xs={4}>
                                    <Typography variant="body2">{row.description || '-'}</Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Typography variant="body2">{row.section || '-'}</Typography>
                                </Grid>
                                <Grid item xs={1.2}>
                                    <Typography variant="body2">{row.code || '-'}</Typography>
                                </Grid>
                                <Grid item xs={1.2}>
                                    <Typography variant="body2">
                                        {row.tax != null ? Number(row.tax).toLocaleString('en-IN') : '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1.3}>
                                    <Typography variant="body2">
                                        {row.surcharge != null ? Number(row.surcharge).toLocaleString('en-IN') : '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1.1}>
                                    <Typography variant="body2">
                                        {row.cess != null ? Number(row.cess).toLocaleString('en-IN') : '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={1.2}>
                                    <Typography variant="body2" fontWeight={600}>
                                        {row.total != null ? Number(row.total).toLocaleString('en-IN') : '-'}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                )}

                <Stack direction="row" justifyContent="flex-end" mt={2.5}>
                    <Button
                        onClick={handleCloseViewBreakupDialog}
                        variant="contained"
                        sx={{ textTransform: 'none', backgroundColor: '#0d3b66' }}
                    >
                        Close
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );

    const renderUploadDialog = () => (
        <Dialog
            open={openUploadDialog}
            onClose={handleCloseDialog}
            maxWidth="lg"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    border: '1px solid #e0e0e0',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.1)',
                    overflow: 'hidden',
                },
            }}

        >

            <DialogContent sx={{ mt: 2 }}>

                {CustomRadioButtons()}

                <ValidatorForm
                    useRef="form"
                    onSubmit={handleSubmit}
                    onError={(errors) => console.log(errors)}
                >
                    {uploadMode === "upload" ? (
                        <Box
                            sx={{
                                border: '2px dashed #90caf9',
                                borderRadius: 2,
                                p: 4,
                                textAlign: 'center',
                                backgroundColor: '#f5faff',
                                width: '100%',
                                maxWidth: 400,
                                mx: 'auto',
                                position: 'relative',
                            }}
                        >
                            <UploadFileIcon sx={{ fontSize: 50, color: '#1976d2', mb: 1 }} />

                            <Typography variant="body1" gutterBottom fontWeight={500}>
                                Click below to upload Challan PDF
                            </Typography>

                            <Button
                                variant="contained"
                                component="label"
                                sx={{ textTransform: 'none', fontWeight: 500 }}
                            >
                                Select PDF
                                <input
                                    hidden
                                    type="file"
                                    accept=".pdf"
                                    onChange={handleFileChange}
                                />
                            </Button>

                            {file && (
                                <>
                                    <Typography
                                        variant="caption"
                                        display="block"
                                        mt={2}
                                        sx={{ fontStyle: 'italic', fontSize: '0.85rem' }}
                                    >
                                        Selected File: {fileName}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() => setFile(null)}
                                        sx={{ position: 'absolute', top: 8, right: 8 }}
                                        title="Remove File"
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </>
                            )}

                            {!file && showFileError && (
                                <Typography variant="caption" color="error" mt={1} display="block">
                                    Please upload a PDF file before submitting.
                                </Typography>
                            )}
                        </Box>

                    ) : (
                        <Grid container spacing={4}>
                            {challanType === '26Q' ? (
                                <>

                                    <Grid item xs={12} sm={6} md={4}>


                                        <SelectInput
                                            choice_id="id"
                                            requiredField="*"
                                            validator={["required"]}
                                            errorMsg={["This field is required"]}
                                            choice_name="value"
                                            SelectLabel="Financial Year"
                                            name="financial_year"
                                            value={formData.financial_year ?? ""}
                                            textOnchangeFunction={handleChange}
                                            choices={financialYears}

                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} mt={2}>
                                        <Autocomplete
                                            options={months}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            value={months.find((opt) => opt.value === formData.month) || null}
                                            onChange={(e, newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    month: newValue?.value || "",
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextValidator
                                                    {...params}
                                                    name="month"
                                                    label={
                                                        <span>
                                                            Month <span style={{ color: 'red' }}>*</span>
                                                        </span>
                                                    }
                                                    variant="outlined"
                                                    value={formData.month}
                                                    size="small"
                                                    validators={["required"]}
                                                    errorMessages={["This field is required"]}
                                                />
                                            )}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    fontSize: '1rem',
                                                    height: 42,
                                                    minHeight: 42,
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} mt={2}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    TAN <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="tan"
                                            value={formData.tan}
                                            onChange={handleChange}
                                            placeholder="AAAA12345A"
                                            validators={['required', "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                                            errorMessages={['This field is required', 'Invalid format (e.g., ABCD12345Z)']}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 10 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator

                                            label={
                                                <span>
                                                    Major Head <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="major_head"
                                            value={formData.major_head}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 15 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            select
                                            label={
                                                <span>
                                                    Minor Head <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="minor_head"
                                            value={formData.minor_head}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            SelectProps={{
                                                MenuProps: {
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value="TDS/TCS payable By Taxpayer(200)">TDS/TCS payable By Taxpayer(200)</MenuItem>
                                            <MenuItem value="TDS/TCS Regular Assessment Raised by it Department(400)">TDS/TCS Regular Assessment Raised by it Department(400)</MenuItem>
                                        </TextValidator>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Nature of Payment <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="nature_of_payment"
                                            value={formData.nature_of_payment}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Basic Tax <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="basic_tax"
                                            value={formData.basic_tax}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 15 }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Surcharge <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="surcharge"
                                            value={formData.surcharge}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, surcharge: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            inputProps={{ maxLength: 15 }}
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Health and Education Cess <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="education_cess"
                                            value={formData.education_cess}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, education_cess: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            inputProps={{ maxLength: 15 }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Penalty <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="penalty"
                                            value={formData.penalty}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, penalty: '' }));
                                                }
                                            }}
                                            fullWidth
                                            inputProps={{ maxLength: 15 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            size="small"
                                            variant="outlined"
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Interest
                                                </span>
                                            }
                                            name="interest"
                                            value={formData.interest}
                                            onChange={handleChange}

                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Fee Under Sec 234E
                                                </span>
                                            }
                                            name="fee_234E"
                                            value={formData.fee_234E}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, fee_234E: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Amount Paid <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="amount_paid"
                                            value={formData.amount_paid}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    BSR Code <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="bsr_code"
                                            value={formData.bsr_code}
                                            onChange={handleChange}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required", "matchRegexp:^[0-9]{7}$"]}
                                            errorMessages={["Bsr Code is required", "Must be a Valid Bsr Code"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 7 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} >
                                        <TextValidator
                                            label={
                                                <span>
                                                    Challan Number <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="challan_number"
                                            value={formData.challan_number}
                                            onChange={handleChange}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required", "matchRegexp:^[0-9]{5}$"]}
                                            errorMessages={["Challan Number is required", "Must be a Valid Challan number"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 5 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>

                                        <label>
                                            Date of Receipt
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <ValidatedDatePicker
                                            name="date_of_receipt"
                                            value={formData.date_of_receipt}
                                            onChange={(v) => {
                                                handleChange({
                                                    name: "date_of_receipt",
                                                    value: v,
                                                });
                                            }}

                                            requiredField="*"
                                            validators={[
                                                "required",
                                                "isValidDate"
                                            ]}
                                            errorMessages={[
                                                "This field is required",
                                                "Invalid date format. Use DD/MM/YYYY"
                                            ]}
                                        />
                                    </Grid>
                                    {renderPaymentDetailsButton()}
                                </>
                            ) : challanType === '27Q' ? (
                                // ── Render 27Q form fields ──────────────────
                                render27QFormFields()
                            ) : (
                                <>
                                    <Grid item xs={12} sm={6} md={4}>


                                        <SelectInput
                                            choice_id="id"
                                            requiredField="*"
                                            validator={["required"]}
                                            errorMsg={["This field is required"]}
                                            choice_name="value"
                                            SelectLabel="Financial Year"
                                            name="financial_year"
                                            value={formData.financial_year ?? ""}
                                            textOnchangeFunction={handleChange}
                                            choices={financialYears}

                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} mt={2}>
                                        <Autocomplete
                                            options={months}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option.value === value.value}
                                            value={months.find((opt) => opt.value === formData.month) || null}
                                            onChange={(e, newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    month: newValue?.value || "",
                                                }));
                                            }}
                                            renderInput={(params) => (
                                                <TextValidator
                                                    {...params}
                                                    name="month"
                                                    label={
                                                        <span>
                                                            Month <span style={{ color: 'red' }}>*</span>
                                                        </span>
                                                    }
                                                    variant="outlined"
                                                    value={formData.month}
                                                    size="small"
                                                    validators={["required"]}
                                                    errorMessages={["This field is required"]}
                                                />
                                            )}
                                            sx={{
                                                '& .MuiInputBase-root': {
                                                    fontSize: '1rem',
                                                    height: 42,
                                                    minHeight: 42,
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} mt={2}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    TAN <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="tan"
                                            value={formData.tan}
                                            onChange={handleChange}
                                            placeholder="AAAA12345A"
                                            validators={["required", "matchRegexp:^[A-Z]{4}[0-9]{5}[A-Z]{1}$"]}
                                            errorMessages={["TAN is required", "Must be a Valid TAN number"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 10 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator

                                            label={
                                                <span>
                                                    Major Head <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="major_head"
                                            value={formData.major_head}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 15 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            select
                                            label={
                                                <span>
                                                    Minor Head <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="minor_head"
                                            value={formData.minor_head}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            SelectProps={{
                                                MenuProps: {
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                        },
                                                    },
                                                },
                                            }}
                                        >
                                            <MenuItem value="TDS/TCS payable By Taxpayer(200)">TDS/TCS payable By Taxpayer(200)</MenuItem>
                                            <MenuItem value="TDS/TCS Regular Assessment Raised by it Department(400)">TDS/TCS Regular Assessment Raised by it Department(400)</MenuItem>
                                        </TextValidator>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Nature of Payment <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="nature_of_payment"
                                            value={formData.nature_of_payment}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Basic Tax <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="basic_tax"
                                            value={formData.basic_tax}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 15 }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Surcharge <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="surcharge"
                                            value={formData.surcharge}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, surcharge: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            inputProps={{ maxLength: 15 }}
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Health and Education Cess <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="education_cess"
                                            value={formData.education_cess}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, education_cess: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            inputProps={{ maxLength: 15 }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Penalty <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="penalty"
                                            value={formData.penalty}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, penalty: '' }));
                                                }
                                            }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                            inputProps={{ maxLength: 15 }}
                                        />
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Late Filing Fee <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="late_filing_fees"
                                            value={formData.late_filing_fees}
                                            onChange={handleChange}

                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            inputProps={{ maxLength: 15 }}
                                            validators={["required"]}
                                            errorMessages={["This field is required", "Maximum length is 15 characters"]}
                                        />
                                    </Grid> */}

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Interest
                                                </span>
                                            }
                                            name="interest"
                                            value={formData.interest}
                                            onChange={handleChange}

                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Fee Under Sec 234E
                                                </span>
                                            }
                                            name="fee_234E"
                                            value={formData.fee_234E}
                                            onChange={handleChange}
                                            onFocus={(e) => {
                                                if (e.target.value === '0') {
                                                    setFormData((prev) => ({ ...prev, fee_234E: '' }));
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    Amount Paid <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="amount_paid"
                                            value={formData.amount_paid}
                                            onChange={handleChange}
                                            validators={["required"]}
                                            errorMessages={["Required"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <TextValidator
                                            label={
                                                <span>
                                                    BSR Code <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="bsr_code"
                                            value={formData.bsr_code}
                                            onChange={handleChange}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required", "matchRegexp:^[0-9]{7}$"]}
                                            errorMessages={["Bsr Code is required", "Must be a Valid Bsr Code"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 7 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} >
                                        <TextValidator
                                            label={
                                                <span>
                                                    Challan Number <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }
                                            name="challan_number"
                                            value={formData.challan_number}
                                            onChange={handleChange}
                                            onKeyPress={(e) => {
                                                if (!/^[0-9.]$/.test(e.key)) e.preventDefault();
                                                if (e.key === '.' && e.target.value.includes('.')) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            validators={["required", "matchRegexp:^[0-9]{5}$"]}
                                            errorMessages={["Challan Number is required", "Must be a Valid Challan number"]}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            inputProps={{ maxLength: 5 }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4} style={{ marginTop: "-20px" }} >

                                        <label>
                                            Date of Receipt
                                            <span style={{ color: "red" }}>*</span>:
                                        </label>
                                        <ValidatedDatePicker
                                            name="date_of_receipt"
                                            value={formData.date_of_receipt}
                                            onChange={(v) => {
                                                handleChange({
                                                    name: "date_of_receipt",
                                                    value: v,
                                                });
                                            }}

                                            requiredField="*"
                                            validators={[
                                                "required",
                                                "isValidDate"
                                            ]}
                                            errorMessages={[
                                                "This field is required",
                                                "Invalid date format. Use DD/MM/YYYY"
                                            ]}
                                        />
                                    </Grid>
                                    {renderPaymentDetailsButton()}
                                </>
                            )}
                        </Grid>
                    )}

                    <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
                        <Button onClick={handleCloseDialog} color="secondary" sx={{ textTransform: "none" }}>
                            Cancel
                        </Button>
                        <LoadingButton loading={challanSubmitLoading} type="submit" variant="contained" sx={{ textTransform: "none" }} startIcon={<SaveIcon />}>
                            Save Challan
                        </LoadingButton>
                    </Stack>
                </ValidatorForm>

                {renderPaymentBreakupDialog()}

            </DialogContent>
        </Dialog>
    );


    const handleMonthSelectionChange = (event, value) => {
        const isSelectAll = value.some((item) => item.value === 'ALL');

        if (isSelectAll) {
            if (selectedMonths.length === monthsOptions.length - 1) {
                setSelectedMonths([]);
            } else {
                const allMonths = monthsOptions.filter((opt) => opt.value !== 'ALL');
                setSelectedMonths(allMonths);
            }
        } else {
            setSelectedMonths(value);
        }
    };


    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };


    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleConfirm = () => {
        const monthsSelected = selectedMonths.map((item) => item.value);
        const item = {
            ...selectedItem,
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: selectedItem?.financial_year,
            month_name: monthsSelected,
            challan_no: selectedItem?.challan_no,
            repository_amount: selectedItem?.amount_paid || 0,
            associated_amount: selectedItem?.associated_amount || 0,
            challan_type: challanType,
            previousView: statusView
        };

        history.push({
            pathname: `/TdsChallanAssociate`,
            state: { items: item }
        });
    };


    // const handleConfirm = () => {
    //     let item = {}
    //     if (selectedItem?.is_pdf_upload) {
    //         const monthsSelected = selectedMonths.map((item) => item.value)
    //         item = {
    //             ...selectedItem,
    //             business_entity_id: localStorage.getItem('business_entity_id'),
    //             financial_year: selectedItem?.financial_year,
    //             month_name: monthsSelected,
    //             challan_no: selectedItem?.challan_no,
    //             repository_amount: selectedItem?.amount_paid || 0,
    //             associated_amount: selectedItem?.associated_amount || 0,
    //             challan_type: challanType,
    //             previousView: statusView
    //         }
    //     } else {
    //         item = {
    //             ...selectedItem,
    //             business_entity_id: localStorage.getItem('business_entity_id'),
    //             financial_year: selectedItem?.financial_year,
    //             month_name: [selectedItem?.month_name],
    //             challan_no: selectedItem?.challan_no,
    //             repository_amount: selectedItem?.amount_paid || 0,
    //             associated_amount: selectedItem?.associated_amount || 0,
    //             challan_type: challanType,
    //             previousView: statusView
    //         }
    //     }

    //     history.push({
    //         pathname: `/TdsChallanAssociate`,
    //         state: { items: item }
    //     })
    // };

    const handleCloseAssociateDialog = () => {
        setSelectedMonths([]);
        setOpenMonthDialog(false);
    };


    // ── Helper: pick the right columns for the active challanType ──────────
    const getActiveColumns = () => {
        if (challanType === '24Q') return columnsTdsChallanRepoTable24Q;
        if (challanType === '27Q') return columnsTdsChallanRepoTable27Q;
        return columnsTdsChallanRepoTable;
    };
    // ────────────────────────────────────────────────────────────────────────

    return (
        <>
            {/* Back Button - placed at the very top */}
            <div style={{
                padding: "15px 20px",
                backgroundColor: "#f5f5f5",
                marginBottom: "0"
            }}>
                <Tooltip title="Back" arrow>
                    <IconButton
                        onClick={handleBackNavigation}
                        sx={{
                            borderRadius: '50%',
                            padding: '6px',
                            color: '#263238',
                            fontSize: '20px',
                            backgroundColor: '#ffffff',
                            height: '36px',
                            width: '36px',
                            '&:hover': {
                                backgroundColor: '#455a64',
                                color: '#ffffff',
                            },
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                </Tooltip>
            </div>

            {/* Main content */}
            <Box sx={{ width: '100%', mx: 'auto' }}>

                <Stack direction="row" justifyContent="space-between" width="100%">

                    <Stack direction="row" justifyContent="flex-start" mb={4}>

                        <ToggleButtonGroup
                            size="small"
                            value={statusView}
                            exclusive
                            onChange={(_, newView) => newView && setStatusView(newView)}
                        >
                            <ToggleButton
                                value="unassociated"
                                sx={{
                                    gap: 0.5,
                                    '&.Mui-selected': {
                                        bgcolor: 'primary.main',
                                        color: 'common.white',
                                        '&:hover': { bgcolor: 'primary.dark' },
                                    },
                                }}
                            >
                                <PaymentIcon fontSize="small" />
                                <Typography variant="caption">Unassociated</Typography>
                            </ToggleButton>
                            <ToggleButton
                                value="associated"
                                sx={{
                                    gap: 0.5,
                                    '&.Mui-selected': {
                                        bgcolor: 'primary.main',
                                        color: 'common.white',
                                        '&:hover': { bgcolor: 'primary.dark' },
                                    },
                                }}
                            >
                                <CreditScoreIcon fontSize="small" />
                                <Typography variant="caption">Associated</Typography>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Stack>


                    <Stack direction="row" justifyContent="end" mb={4}>
                        {canWrite("TDS-FILING") && (
                            <Button
                                variant="contained"
                                startIcon={<IosShareIcon />}
                                color="primary"
                                sx={{ textTransform: 'none', fontWeight: 600 }}
                                onClick={() => setOpenUploadDialog(true)}
                            >
                                Upload Challan
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            color="success"
                            sx={{ textTransform: 'none', fontWeight: 600, marginLeft: 3 }}
                            disabled={isExportingExcel}
                            onClick={handleDownloadReport}
                            endIcon={isExportingExcel ? (
                                <span
                                    style={{
                                        width: "12px",
                                        height: "12px",
                                        border: "2px solid currentColor",
                                        borderTopColor: "transparent",
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        animation: "spin 0.7s linear infinite",
                                        flexShrink: 0,
                                    }}
                                />
                            ) : (
                                <img
                                    src={excelIconImage}
                                    alt="Excel"
                                    style={{ width: 20, height: 20 }}
                                />
                            )}
                        >
                            {isExportingExcel ? "Exporting..." : "Export"}
                        </Button>
                    </Stack>

                </Stack>

                {/* ── Single DataGridPro driven by getActiveColumns() ── */}
                <DataGridPro
                    rows={tdsChallanRepoData}
                    columns={getActiveColumns()}
                    autoHeight
                    getRowId={(row) => row.id}
                    loading={dataLoading}
                    sx={{
                        backgroundColor: '#fff',
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: '#455a64',
                            color: '#fff',
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f5f5f5',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#e3f2fd',
                            cursor: 'pointer',
                        },
                    }}
                    pagination
                    pageSize={pageSize}
                    pageSizeOptions={[5, 10, 25, 50]}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePageChange}
                />

                {renderUploadDialog()}
                {renderViewBreakupDialog()}

                <Dialog open={openAssociateDialog} onClose={handleCloseAssociateDialog} maxWidth="sm" fullWidth>
                    <DialogTitle sx={{ fontWeight: 600, backgroundColor: '#f1f8ff' }}>
                        {!selectedItem?.is_pdf_upload ? 'Confirm Association' : 'Select Months to Associate'}
                    </DialogTitle>
                    <DialogContent sx={{ mt: 2, minHeight: '200px' }}>
                        {!selectedItem?.is_pdf_upload && (
                            <TextField
                                label="Challan Number"
                                value={selectedItem?.challan_no || ''}
                                fullWidth
                                disabled
                                margin="normal"
                            />
                        )}

                        <Autocomplete
                            multiple
                            options={monthsOptions}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.label}
                            value={selectedMonths}
                            onChange={handleMonthSelectionChange}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Months"
                                    placeholder="Select months"
                                    size="small"
                                />
                            )}
                            PopperComponent={(props) => <Popper {...props} placement="top-start" />}
                        />

                        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={4}>
                            <Button onClick={handleCloseAssociateDialog} color="secondary" sx={{ textTransform: 'none' }}>
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleConfirm}
                                disabled={selectedMonths.length === 0}
                                sx={{ textTransform: 'none' }}
                            >
                                Confirm
                            </Button>
                        </Stack>
                    </DialogContent>
                </Dialog>


                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                    open={snackbarOpen}
                    autoHideDuration={4500}
                    onClose={handleSnackbarClose}
                    style={{ maxWidth: '25%' }}
                >
                    <MuiAlert
                        elevation={6}
                        variant="filled"
                        onClose={handleSnackbarClose}
                        severity={snackbarSeverity}
                    >
                        {responseMessage}
                        {message}
                    </MuiAlert>
                </Snackbar>

                <Dialog
                    open={confirmDiscardOpen}
                    onClose={() => setConfirmDiscardOpen(false)}
                >
                    <DialogTitle>Discard Changes?</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2">
                            You have unsaved changes. Are you sure you want to discard them?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmDiscardOpen(false)} color="primary">
                            Continue Editing
                        </Button>
                        <Button
                            onClick={() => {
                                setConfirmDiscardOpen(false);
                                closeAndResetForm();
                            }}
                            color="error"
                        >
                            Discard
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box>
        </>
    );
};

export default TDSChallanRepository;